import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { IonicModule } from '@ionic/angular/lazy';
import { ChatService } from '../../services/chat.service';
import { Subject, takeUntil } from 'rxjs';
import { addIcons } from 'ionicons';
import { chatbubbles } from 'ionicons/icons';

/**
 * Floating chat button. Toggles the unified chat overlay (hosted by the app
 * shell) on every form factor — the shell decides how the overlay presents.
 */
@Component({
    selector: 'app-chat-toggle',
    templateUrl: './chat-toggle.component.html',
    styleUrls: ['./chat-toggle.component.scss'],
    imports: [IonicModule]
})
export class ChatToggleComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private chatService = inject(ChatService);

  isOpen = false;
  unreadCount = 0;

  constructor() {
    addIcons({ chatbubbles });
  }

  ngOnInit() {
    this.chatService.isOpen
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOpen => {
        this.isOpen = isOpen;
      });

    this.chatService.unreadCount
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.unreadCount = count;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleChat(): void {
    this.chatService.toggleChat();
  }
}
